import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2, Mail, Download } from 'lucide-react';
import { newsletterApi, files as filesApi } from '../services/api';
import { toast } from '../hooks/use-toast';

const isExternal = (u) => /^(https?:|mailto:|tel:)/.test(u || '');

function NewsletterButton({ cid, b }) {
  const navigate = useNavigate();
  const go = () => {
    newsletterApi.click(cid, b.id).catch(() => {});
    if (b.linkType === 'file' || isExternal(b.url) || (b.url || '').startsWith('/api/')) window.open(filesApi.urlFor(b.url), '_blank', 'noopener');
    else navigate(b.url || '/');
  };
  return (
    <div data-testid={`nl-view-button-${b.id}`}>
      {b.sponsor && <div className="text-[11px] uppercase tracking-wider text-yellow-400 mb-1">Sponsored</div>}
      {b.kind === 'image' && b.image ? (
        <button onClick={go} className="block w-full"><img src={filesApi.urlFor(b.image)} alt={b.label || ''} className="w-full rounded-lg" /></button>
      ) : (
        <button onClick={go} className="w-full rounded-lg bg-green-600 hover:bg-green-700 text-white font-semibold py-3.5 px-4 inline-flex items-center justify-center gap-2">
          {b.linkType === 'file' && <Download size={16} />}{b.label || 'Learn more'}
        </button>
      )}
    </div>
  );
}

export default function NewsletterView() {
  const [n, setN] = useState(null);
  useEffect(() => {
    newsletterApi.latest().then(d => {
      setN(d);
      if (d.pointsAwarded > 0) toast({ title: `+${d.pointsAwarded} points`, description: 'Thanks for reading this week’s newsletter!' });
    }).catch(() => setN({}));
  }, []);
  if (n === null) return <div className="p-6"><Loader2 className="animate-spin text-gray-400" /></div>;
  if (!n.id) return (
    <div className="max-w-xl mx-auto pbb-card p-8 text-center" data-testid="nl-view-empty">
      <Mail className="mx-auto text-green-400" size={36} />
      <div className="mt-3 text-lg font-semibold text-white">No newsletter yet</div>
      <p className="mt-1 text-sm text-gray-300">The first PBB newsletter is on its way. Check back soon!</p>
    </div>
  );
  return (
    <div className="max-w-2xl mx-auto space-y-4" data-testid="nl-view">
      <div>
        <h1 className="text-2xl font-bold text-white inline-flex items-center gap-2"><Mail size={22} className="text-green-400" /> Newsletter</h1>
        <p className="text-sm text-gray-300">Latest issue · {new Date(n.publishedAt).toLocaleDateString()}</p>
      </div>
      <div className="rounded-xl overflow-hidden bg-white" data-testid="nl-view-content">
        {(n.contentImages || []).map((u, i) => <img key={i} src={filesApi.urlFor(u)} alt="" className="block w-full h-auto" data-testid={`nl-view-image-${i}`} />)}
      </div>
      {n.buttons?.length > 0 && <div className="space-y-3" data-testid="nl-view-buttons">{n.buttons.map(b => <NewsletterButton key={b.id} cid={n.id} b={b} />)}</div>}
    </div>
  );
}
